import { useTheme } from "../../context/ThemeContext";

export default function PageHeader({
  title,
  subtitle,
  actionButton,
}) {

  const { isDark } = useTheme();

  return (
    <div
      className="
        flex
        flex-col
        lg:flex-row
        lg:items-center
        lg:justify-between
        gap-6
      "
    >
      <div>

        <span
          className={`
            text-sm
            uppercase
            tracking-[0.2em]
            ${
              isDark
                ? "text-gray-400"
                : "text-gray-500"
            }
          `}
        >
          {subtitle}
        </span>

        <h1
          className="
            mt-2
            text-4xl
            font-bold
          "
        >
          {title}
        </h1>

      </div>

      {actionButton}

    </div>
  );
}